import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { UserUpdateSettingRequestModel } from '@/modules/user/models/user-request.model'

@vservice()
export class AdminUserUpdateSettingUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminUserService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(id: number, data: UserUpdateSettingRequestModel) {
    return this.service.updateSetting(id, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
